import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.dashboard.DashboardView.hint.p1")}</p>
    <ol>
      <li>{I18n.t("papp.dashboard.DashboardView.hint.p2")}</li>
      <li>{I18n.t("papp.dashboard.DashboardView.hint.p3")}</li>
      <li>{I18n.t("papp.dashboard.DashboardView.hint.p4")}</li>
      <li>{I18n.t("papp.dashboard.DashboardView.hint.p5")}</li>
    </ol>
    <p>
      {I18n.tt("papp.dashboard.DashboardView.hint.p6", {
        tel: (
          <a href={`tel:${I18n.t("papp.common.st_phone_number").replace(/\s/g, "")}`}>
            {I18n.t("papp.common.st_phone_number")}
          </a>
        ),
        email: <a href={`mailto:${I18n.t("papp.common.st_email")}`}>{I18n.t("papp.common.st_email")}</a>,
      })}
    </p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/dashboard/DashboardHint.jsx